import React from "react";
import PropTypes from "prop-types";
import Picture from "../../components/Picture";
import SimpleAccordionContainer from "../../components/site/Accordion/SimpleAccordionContainer";
import SimpleAccordionItem from "../../components/site/Accordion/SimpleAccordionItem";

import "./IndustriesAndDistributors.scss";

const IndustriesAndDistributorsTest = ({ imageSrc, imageAlt, titleTag }) => {
  const TitleTag = titleTag || 'p';

  return (
    <div className="industries-distributors-section">
      <div className="container">
        <div className="content-wrapper">
          <div className="features-list">
            <div className="section-header">
              <p className="section-overtitle">Gestão alinhada e controle total</p>
              <TitleTag className="section-title">Indústrias e Distribuidoras</TitleTag>
              <p className="section-description">Sincronize políticas comerciais e estoque em tempo real com os vendedores, otimize processos e impulsione as vendas. Tudo isso enquanto integra o Mercos a qualquer ERP</p>
            </div>
            <SimpleAccordionContainer expand="arrow" collapsable>
              <SimpleAccordionItem title="Fim dos erros e retrabalhos">
                <p>Gerenciamento de ponta a ponta da operação comercial em um sistema intuitivo, com processos padronizados e sem digitação manual</p>
              </SimpleAccordionItem>
              <SimpleAccordionItem title="Informações centralizadas">
                <p>Indicadores, relatórios e o cruzamento de dados entre o Mercos e seu ERP, garantindo insights estratégicos</p>
              </SimpleAccordionItem>
              <SimpleAccordionItem title="Expansão do seu negócio e vendas">
                <p>Recursos inteligentes que aumentam a produtividade da equipe, automatizam processos e dão mais controle para a gestão focar em crescimento de verdade</p>
              </SimpleAccordionItem>
            </SimpleAccordionContainer>
          </div>
          <div className="main-image">
            <Picture className="img" src={imageSrc || "/images/site/new-home/update/ind.png"} alt={imageAlt || "Imagem do sistema de vendas Mercos na parte esquerda e inferior da imagem, na versão mobile (app), aparecendo na tela de um celular, com um cliente e informações sobre seu pedido. Também há a versão desktop, no centro ao lado direito da imagem, mostrando a tela inicial do sistema com foco na aba de Indicadores, focando os indicadores Conversão do E-commerce, Carteira de Clientes e Curva ABC de Clientes."} />
          </div>
        </div>
        <div className="icon-features">
          <div className="icon-feature-item">
            <div className="icon-wrapper">
              <Picture loading="lazy" src="/images/site/icons/tree.png" alt="ERP Integrado" />
            </div>
            <div className="icon-feature-content">
              <p className="icon-feature-title">ERP<br />Integrado</p>
              <p className="icon-feature-description">Com a integração a qualquer ERP, seu time digita pedidos e informações uma vez só</p>
            </div>
          </div>
          <div className="icon-feature-item">
            <div className="icon-wrapper">
              <Picture loading="lazy" src="/images/site/icons/person-frame.png" alt="Portal do Cliente e E-commerce B2B" />
            </div>
            <div className="icon-feature-content">
              <p className="icon-feature-title">Portal do Cliente e<br />E-commerce B2B</p>
              <p className="icon-feature-description">Permita que os clientes façam pedidos e acessem históricos e segundas vias de NFs</p>
            </div>
          </div>
          <div className="icon-feature-item">
            <div className="icon-wrapper">
              <Picture loading="lazy" src="/images/site/icons/flag-white.png" alt="Políticas Comerciais" />
            </div>
            <div className="icon-feature-content">
              <p className="icon-feature-title">Políticas<br />Comerciais</p>
              <p className="icon-feature-description">Defina regras claras de preços, descontos e condições de pagamento, evitando erros</p>
            </div>
          </div>
          <div className="icon-feature-item">
            <div className="icon-wrapper">
              <Picture loading="lazy" src="/images/site/icons/sheet.png" alt="Controle de produtos em estoque" />
            </div>
            <div className="icon-feature-content">
              <p className="icon-feature-title">Controle de produtos em estoque</p>
              <p className="icon-feature-description">Controle do estoque em tempo real, evitando vender itens indisponíveis</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

IndustriesAndDistributorsTest.propTypes = {
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
  titleTag: PropTypes.string,
};

IndustriesAndDistributorsTest.defaultProps = {
  imageSrc: null,
  imageAlt: null,
  titleTag: 'p',
};

export default IndustriesAndDistributorsTest;



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/TwoCols/IndustriesAndDistributorsTest.jsx